import React from "react";
import { VscError } from "react-icons/vsc";
import { FailWrapper } from "../styled/Fail.styled";
export default function Fail() {
  return (
    <FailWrapper data-testid="fail-wrapper-test">
      <VscError data-testid="error-icon-test" />
    </FailWrapper>
  );
}
